<template>
  <b-container
    class="m-2 study-element"
    fluid
  >
    <b-row class="title-section mx-0 my-3">
      <SimpleTextInputConfiguration
        :controller="LegendCrtller"
        classname="main-name-input px-0"
        class="w-100"
      />
    </b-row>
    <b-row class="m-0">
      <b-container
        class="m-0"
        fluid
      >
        <StateSelector :sectionconfig="sectionconfig" />
        <b-row
          v-if="isVisibleReverseCurrent"
          class="text-center title-subsection mr-1 mt-2"
        >
          <p>Configuration</p>
        </b-row>
        <b-row
          v-if="isVisibleReverseCurrent"
          class="pl-2"
        >
          <p class="m-0 p-0 extra-message">
            Reverse current detected in files
          </p>
        </b-row>
        <b-row
          v-if="isVisibleReverseCurrent"
          class="m-0 p-0"
        >
          <DropdownConfiguration :controller="ReverseCurrentCtller" />
        </b-row>
        <b-row class="text-center title-subsection mr-1 mt-2">
          <p>Axis</p>
        </b-row>
        <HeaderConfiguration />
        <PotentialConfiguration
          axis="X"
          :sectionconfig="sectionconfig"
        />
        <CurrentConfiguration
          axis="Y"
          :sectionconfig="sectionconfig"
        />
        <PreprocessingSelection :sectionconfig="sectionconfig" />
        <b-row class="text-center title-subsection mr-1 mt-2">
          <p>Analysis</p>
        </b-row>
        <b-row align-v="center">
          <CheckBoxConfiguration
            :controller="ExtractedValues"
            :switchprop="true"
          />
        </b-row>
        <DeltaFit :sectionconfig="sectionconfig" />
        <MeanFit :sectionconfig="sectionconfig" />
        <PeakPosFit :sectionconfig="sectionconfig" />
        <PeakHeightFit :sectionconfig="sectionconfig" />
        <PeakAUCFit :sectionconfig="sectionconfig" />
        <MappingFit :sectionconfig="sectionconfig" />
        <FeatureCheckWrapper :sectionconfig="sectionconfig" />
        <b-row class="text-center title-subsection mr-1 mt-2">
          <p>Extra Configuration</p>
        </b-row>
        <ExcludeConcentrations :sectionconfig="sectionconfig" />
      </b-container>
    </b-row>
  </b-container>
</template>

<script>
import CheckBoxConfiguration from '../elements/CheckBoxConfiguration'
import DropdownConfiguration from '../elements/DropdownConfiguration'
import PreprocessingSelection from '../elements/preprocessing/PreprocessingSelection'
import PeakPosFit from '@/components/properties/elements/fit/PeakPosFit'
import PeakHeightFit from '@/components/properties/elements/fit/PeakHeightFit'
import PeakAUCFit from '@/components/properties/elements/fit/PeakAUCFit'
import DeltaFit from '@/components/properties/elements/fit/DeltaFit'
import MeanFit from '@/components/properties/elements/fit/MeanFit'
import StateSelector from '@/components/properties/specificFeatures/StateSelector'
import SimpleTextInputConfiguration from '@/components/properties/elements/SimpleTextInputConfiguration'
import ExcludeConcentrations from '../elements/ExcludeConcentrations'
import FeatureCheckWrapper from '@/components/properties/specificFeatures/FeatureCheckWrapper'
import MappingFit from '@/components/properties/specificFeatures/MappingFit'
import PotentialConfiguration from '../units/PotentialConfiguration'
import HeaderConfiguration from '../units/HeaderConfiguration'
import CurrentConfiguration from '../units/CurrentConfiguration'
import {checkBoxGraphConfCtrller,fixedConfCtrller,comboBoxConfCtrller, simpleInputTextConfCtrller} from '@/assets/classes/configuration.js'
import { PlotType } from '@/common/plotDefinitions.js'
import { ExtraConfigKey, ConfigName, NameExtraConfig } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapGetters } from 'vuex'

const rootContextFolder='ReportViewer/Studies/VD/'

export default {
  name: 'DiscreteStudyVD',
  components:{
    CheckBoxConfiguration,
    DropdownConfiguration,
    PreprocessingSelection,
    StateSelector,
    ExcludeConcentrations,
    FeatureCheckWrapper,
    PotentialConfiguration,
    HeaderConfiguration,
    CurrentConfiguration,
    PeakPosFit,
    PeakHeightFit,
    PeakAUCFit,
    DeltaFit,
    MeanFit,
    MappingFit,
    SimpleTextInputConfiguration
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
    typestudy:{
      type:String,
      required: true
    }
  },
  data() {
    return {
      ConfigName,
      ExtraConfigKey,
      NameExtraConfig,
      elementsConfig: [],
      LegendCrtller: new simpleInputTextConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.legendStudy}`,'', ''),
      typeXaxisCrtller: new fixedConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.xAxisType}`,''),
      typeYaxisCrtller: new fixedConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.yAxisType}`,''),
      ReverseCurrentCtller: new comboBoxConfCtrller(`${ConfigName.BasePropStudy}.${ConfigName.CurrentDirectionReverse}`,[
          {text:'Forward',value:'Forward_Current'},
          {text:'Reverse',value:'Reverse_Current'},
          {text:'Difference',value:'Difference_Current'}
        ],'Current Direction',0,rootContextFolder+'ReverseCurrent'
      ),
      ExtractedValues: new checkBoxGraphConfCtrller(ConfigName.ReqExtractedValsDiscrete,'Show extracted values',false,rootContextFolder+'ExtractedValsDiscrete'),
      title:'',
      BaselineExpanded:false,
      DeltaFitGraphExpanded:true,
      MeanFitGraphExpanded:true,
      StatisticalEvalExpanded:true,
      isVisibleReverseCurrent:false,
    }
  },
  computed:mapGetters(['getCurrentReportViewer']),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted(){
    this.configureStudy()
    this.isVisibleReverseCurrent = typeof(this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent])!=='undefined' && this.getCurrentReportViewer[ExtraConfigKey][NameExtraConfig.ReverseCurrentPresent]
  },
  methods: {
    configureStudy(){
      this.elementsConfig = [
        this.LegendCrtller,
        this.typeXaxisCrtller,
        this.typeYaxisCrtller,
        this.ReverseCurrentCtller,
        this.ExtractedValues
      ]
      this.typeXaxisCrtller.value = PlotType[this.typestudy].xAxisType
      this.typeYaxisCrtller.value = PlotType[this.typestudy].yAxisType
      this.title = PlotType[this.typestudy].text.replace(this.typestudy, this.sectionconfig)
      this.LegendCrtller.defaultValue=this.title
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.setParent(this))
    }
  }
}
</script>

<style lang="scss" scoped>
.expanded-info{
  background-color: #DDD;
  border-radius: 5px;
}
.range-display{
  font-weight: bold;
  text-align: center;
  font-size: 0.8;
}
.short-message{
  font-size:0.7rem;
  font-weight: bold;
  margin:0;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group{
  width:75%;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.extra-message{
  font-weight:lighter;
}
.label-internal-category{
  font-weight: bold;
}
::v-deep .main-name-input {
  font-size: 1rem;
  font-weight: bold;
  background-color: transparent;
  border: 0px solid;
}
</style>